import appEvents from 'events/app';
import sessionEvents from 'events/session';
import messageEvents from 'events/messages';
import initializeApp from 'actions/app/initializeApp';
import computeUnreadMessageCount from 'actions/messages/computeUnreadMessageCount';
import evaluateRules from 'actions/configuration/evaluateRules';
import userSelectors from 'selectors/user';
import appSelectors from 'selectors/app';

export default (async function authenticateWithChatProvider(dispatch, getState, { chatGateway, messageGateway }) {
  const state = getState();
  const authCredentials = userSelectors.getCredentials(state.user);
  const gladlyCustomerId = userSelectors.getGladlyCustomerId(state.user);
  const appId = appSelectors.getAppId(state.app);

  try {
    await chatGateway.login(authCredentials, gladlyCustomerId, appId);
    dispatch(appEvents.clientAuthenticationSuccess({ gladlyCustomerId }));

    // TODO: remove
    // this doesnt belong here. it should be called separately
    const session = chatGateway.getSession();
    if (session) {
      dispatch(sessionEvents.sessionFetchSuccess(session));

      const messages = messageGateway.fetchMessages();
      messages.forEach(message => dispatch(messageEvents.createOrUpdateMessageSuccess(message)));
      dispatch(computeUnreadMessageCount);
    } else {
      dispatch(evaluateRules);
    }
  } catch (error) {
    dispatch(appEvents.clientAuthenticationError(error));
  }

  dispatch(initializeApp);
});
